

import "./MenuLateral.scss";
import { Button } from "react-bootstrap";
import { useContext, useState } from "react";
import { PageContext, usePage } from "../services/PageContext";
import { Link, useNavigate } from "react-router-dom";
import { GlobalFunctionsContext } from "../services/GlobalFunctionsContext";
import { List, X } from "react-bootstrap-icons";

export default function MenuLateral({categorias, catId, brandId, marcas}) {
  const { resetPages } = useContext(PageContext);
  const { convertStringToLink } = useContext(GlobalFunctionsContext);
  const { isMobileStyle } = usePage()

  const [sidebar, setSidebar] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);

  const navigate = useNavigate();
  
  const handleClickLink = (link) => {
    localStorage.removeItem('productoAgregado');
    resetPages();
    navigate(link);
  }

  return (
    <>
      {isMobileStyle
      ? <div className={`catalog-filter is-mobile ${sidebar ? 'active' : ''}`}>
          <nav className={sidebar ? "nav-menu active" : "nav-menu"}>
            <ul className="nav-menu-items" onClick={showSidebar}>
              <li className="navbar-toggle">
                <Link to="#" className="menu-bars">
                  {!sidebar
                    ?<List />
                    :<X />
                  }
                </Link>
              </li>
              <div className="menu">
                {categorias.length > 0 &&
                  (<div className="category-group">
                    <h5>Categoría</h5>
                      <div className="list-content">
                        {categorias.map((c, i) => {
                          let categoria = convertStringToLink(c.nombre);
                          return brandId ?
                              (<Button variant="link"  onClick={() => {handleClickLink(`/marca/${brandId}/${c.id}-${categoria}`)}} key={`categoria_${i}`}>
                                {c.nombre} ({c.cantidad})
                              </Button>)
                              :
                              ( <Button variant="link" onClick={() => {handleClickLink(`/categoria/${c.id}-${categoria}`)}} key={`categoria_${i}`}>
                                {c.nombre} ({c.cantidad})
                              </Button>)
                          }
                        )}
                      </div>
                  </div>)
                }
                {marcas.length > 0 &&
                (<>
                    {sidebar && <div className="divider"></div>}
                    <div className="category-group">
                  <h5>Marcas</h5>
                  <div className="list-content">
                      {marcas.map((m, i) => {
                        let brand = convertStringToLink(m.nombre);
                        return brandId ? 
                          (<Button variant="link" onClick={() => {handleClickLink(`/marca/${brandId}`)}} key={`marca_${i}`}>
                            {m.nombre} ({m.cantidad})
                          </Button>)
                          :
                          (<Button variant="link" onClick={() => {handleClickLink(`/categoria/${catId}/${m.id}-${brand}`)}} key={`marca_${i}`}>
                            {m.nombre} ({m.cantidad})
                          </Button>)
                      })}
                  </div>
                </div></>)
                }
              </div>
            </ul>
          </nav>
        </div>
        :<div className="catalog-filter">
          <div className="menu">
            {categorias.length > 0 &&
              (<div className="category-group">
                <h5>Categoría</h5>
                  <div className="list-content">
                    {categorias.map((c, i) => {
                      let categoria = convertStringToLink(c.nombre);
                      return brandId ?
                          (<Button variant="link"  onClick={() => {handleClickLink(`/marca/${brandId}/${c.id}-${categoria}`)}} key={`categoria_${i}`}>
                            {c.nombre} ({c.cantidad})
                          </Button>)
                          :
                          ( <Button variant="link" onClick={() => {handleClickLink(`/categoria/${c.id}-${categoria}`)}} key={`categoria_${i}`}>
                            {c.nombre} ({c.cantidad})
                          </Button>)
                      }
                    )}
                  </div>
              </div>)
            }
            {marcas.length > 0 &&
            (<>
                <div className="divider"></div>
                <div className="category-group">
              <h5>Marcas</h5>
              <div className="list-content">
                  {marcas.map((m, i) => {
                    let brand = convertStringToLink(m.nombre);
                    return brandId ? 
                      (<Button variant="link" onClick={() => {handleClickLink(`/marca/${brandId}`)}} key={`marca_${i}`}>
                        {m.nombre} ({m.cantidad})
                      </Button>)
                      :
                      (<Button variant="link" onClick={() => {handleClickLink(`/categoria/${catId}/${m.id}-${brand}`)}} key={`marca_${i}`}>
                        {m.nombre} ({m.cantidad})
                      </Button>)
                  })}
              </div>
            </div></>)
          }
        </div>
      </div>
      }
    </>
  )
}